import {useQuery} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import { RetailOrderPostInstall } from "../types/RetailOrderPostInstall";

export const useGetPostInstall = () => {

    const { data, isLoading, refetch, isRefetching } = useQuery({
        queryFn: async () => await apiClient.get('retail-order/post-install',
            { params: { } }) as RetailOrderPostInstall[]
    });

    return {
        data: data || [],
        isLoading,
        refetch,
        isRefetching
    };
};
